import { render } from "./LbrxKioskThirdTheme.vue?vue&type=template&id=5fe7992e&scoped=true"
import script from "./LbrxKioskThirdTheme.vue?vue&type=script&lang=js"
export * from "./LbrxKioskThirdTheme.vue?vue&type=script&lang=js"

import "./LbrxKioskThirdTheme.vue?vue&type=style&index=0&id=5fe7992e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fe7992e"]])

export default __exports__